module.exports = __webpack_public_path__ + "static/media/microsoft.a2d81c38.svg";